// extracted by mini-css-extract-plugin
export default {"parent":"parent_parent__aAnSw","parent-title":"parent_parent-title__nb0-4","search":"parent_search__2oFK0","search--label":"parent_search--label__G0gin"};